export default {options:{api:'closure',version:1},children:[{options:{key:'timestamp',type:'value'}},{options:{key:'by',type:'value'}}]}